module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.entity,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.name),
      callback: function($$v) {
        _vm.$set(_vm.entity, "name", $$v)
      },
      expression: "entity.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围",
      "prop": "datetime"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    attrs: {
      "clearable": true,
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.entity.datetime),
      callback: function($$v) {
        _vm.$set(_vm.entity, "datetime", $$v)
      },
      expression: "entity.datetime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区间内有效期",
      "prop": "limitDays"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "限制",
      "inactive-text": "不限"
    },
    model: {
      value: (_vm.entity.limitDays),
      callback: function($$v) {
        _vm.$set(_vm.entity, "limitDays", $$v)
      },
      expression: "entity.limitDays"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entity.limitDays),
      expression: "entity.limitDays"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.entity.effectTimes),
      callback: function($$v) {
        _vm.$set(_vm.entity, "effectTimes", _vm._n($$v))
      },
      expression: "entity.effectTimes"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.entity.effectTimeUnit),
      callback: function($$v) {
        _vm.$set(_vm.entity, "effectTimeUnit", $$v)
      },
      expression: "entity.effectTimeUnit"
    }
  }, _vm._l((_vm.$dict.store.PROMOTION_EFFECT_TIMEUNIT), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "可见性",
      "prop": "visibility"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.entity.visibility),
      callback: function($$v) {
        _vm.$set(_vm.entity, "visibility", $$v)
      },
      expression: "entity.visibility"
    }
  }, _vm._l((_vm.$dict.store.PROMOTION_VISIBILITY), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户限次",
      "prop": "limitPermanTimes"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "限制用户参与次数(0表示不限制)"
    },
    model: {
      value: (_vm.entity.limitPermanTimes),
      callback: function($$v) {
        _vm.$set(_vm.entity, "limitPermanTimes", $$v)
      },
      expression: "entity.limitPermanTimes"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "总量",
      "prop": "limitTotalNum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "限制参与总量(0表示不限制)"
    },
    model: {
      value: (_vm.entity.limitTotalNum),
      callback: function($$v) {
        _vm.$set(_vm.entity, "limitTotalNum", $$v)
      },
      expression: "entity.limitTotalNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠类型",
      "prop": "discountType"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.onDiscountTypeChange
    },
    model: {
      value: (_vm.entity.discountType),
      callback: function($$v) {
        _vm.$set(_vm.entity, "discountType", $$v)
      },
      expression: "entity.discountType"
    }
  }, [_c('el-option', {
    key: "money",
    attrs: {
      "label": "金额",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: "duration",
    attrs: {
      "label": "时长",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    key: "time",
    attrs: {
      "label": "次数",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    key: "other",
    attrs: {
      "label": "其它",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "优惠值",
      "disabled": _vm.entity.discountType == 3
    },
    model: {
      value: (_vm.entity.discountValue),
      callback: function($$v) {
        _vm.$set(_vm.entity, "discountValue", $$v)
      },
      expression: "entity.discountValue"
    }
  }, [(_vm.entity.discountType == 1) ? _c('template', {
    slot: "append"
  }, [_c('span', [_vm._v("元")])]) : (_vm.entity.discountType == 2) ? _c('template', {
    slot: "append"
  }, [_c('span', [_vm._v("小时")])]) : (_vm.entity.discountType == 3) ? _c('template', {
    slot: "append"
  }, [_c('span', [_vm._v("次")])]) : _vm._e()], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠门槛",
      "prop": "dicountCondition"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "优惠门槛说明（如: 无任何门槛）"
    },
    model: {
      value: (_vm.entity.discountCondition),
      callback: function($$v) {
        _vm.$set(_vm.entity, "discountCondition", $$v)
      },
      expression: "entity.discountCondition"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "display",
      rawName: "v-display",
      value: (_vm.entity.status != 0),
      expression: "entity.status!=0"
    }],
    attrs: {
      "label": "优惠规则",
      "prop": "ruleTplCode"
    }
  }, [_c('promotion-rule-def-select', {
    attrs: {
      "discountType": _vm.entity.discountType
    },
    on: {
      "change": _vm.resetProps,
      "loaded": _vm.onRuleDefsLoaded
    },
    model: {
      value: (_vm.entity.ruleTplCode),
      callback: function($$v) {
        _vm.$set(_vm.entity, "ruleTplCode", $$v)
      },
      expression: "entity.ruleTplCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.entity.remark),
      callback: function($$v) {
        _vm.$set(_vm.entity, "remark", $$v)
      },
      expression: "entity.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#aaa",
      "margin-left": "100px"
    }
  }, [_vm._v("注：一旦上线，所属商户、优惠规则不可改变！")])], 1), _vm._v(" "), (_vm.ruleTpl.when || _vm.ruleTpl.then) ? _c('fieldset', {
    directives: [{
      name: "display",
      rawName: "v-display",
      value: (_vm.entity.status != 0),
      expression: "entity.status!=0"
    }]
  }, [_c('legend', [_vm._v("活动规则参数")]), _vm._v(" "), (_vm.ruleTpl.when) ? _c('div', [_c('el-alert', {
    attrs: {
      "title": "条件",
      "description": ""
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("限定规则适用条件参数")])]), _vm._v(" "), _vm._l((_vm.getProps('when')), function(item, index) {
    return _c('el-form-item', {
      key: item.propkey,
      attrs: {
        "label": item.propName,
        "prop": 'props.' + index + '.propValue',
        "rules": {
          required: item.required,
          message: '不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": item.remark
      },
      model: {
        value: (item.propValue),
        callback: function($$v) {
          _vm.$set(item, "propValue", $$v)
        },
        expression: "item.propValue"
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.ruleTpl.then) ? _c('div', [_c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "结果"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("设置结果参数")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.ruleTpl.then.description) + "\n        ")])]), _vm._v(" "), _vm._l((_vm.getProps('then')), function(item, index) {
    return _c('el-form-item', {
      key: item.propkey,
      attrs: {
        "label": item.propName,
        "prop": 'props.' + index + '.propValue',
        "rules": {
          required: item.required,
          message: '不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": item.remark
      },
      model: {
        value: (item.propValue),
        callback: function($$v) {
          _vm.$set(item, "propValue", $$v)
        },
        expression: "item.propValue"
      }
    })], 1)
  })], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6848490c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionInfo/Form.vue
// module id = 345
// module chunks = 0